import type { VehicleTypeFilterValue } from "../filters/value-types";

/**
 * Maps body values from the database to vehicletype filter values
 * This is the single source of truth for vehicletype mapping
 */
export const BODY_TO_VEHICLETYPE_MAP: Record<string, VehicleTypeFilterValue[]> =
  {
    Kleinwagen: ["small"],
    Kombi: ["station-wagon"],
    Limousine: ["sedan"],
    "Sportwagen/Coupé": ["sports-coupe"],
    Cabrio: ["convertible"],
    "Geländewagen / SUV / Pickup": ["suv-pickup"],
    Van: ["commercial"],
    Kastenwagen: ["commercial"],
    "Kastenwagen hoch": ["commercial"],
    "Kastenwagen lang": ["commercial"],
    "Pritsche unter 7,5t": ["commercial"],
    Teilintegrierter: ["camper"],
    Alkoven: ["camper"],
  };

/**
 * Maps vehicletype filter values to body values for database queries
 * This is the reverse mapping of BODY_TO_VEHICLETYPE_MAP
 */
export const VEHICLETYPE_TO_BODY_MAP: Record<VehicleTypeFilterValue, string[]> =
  {
    small: ["Kleinwagen"],
    "station-wagon": ["Kombi"],
    sedan: ["Limousine"],
    "sports-coupe": ["Sportwagen/Coupé"],
    convertible: ["Cabrio"],
    "suv-pickup": ["Geländewagen / SUV / Pickup"],
    commercial: [
      "Van",
      "Kastenwagen",
      "Kastenwagen hoch",
      "Kastenwagen lang",
      "Pritsche unter 7,5t",
    ],
    camper: ["Teilintegrierter", "Alkoven"],
  };

/**
 * Maps body labels to vehicletype filter values
 * Used when aggregating counts from facets
 */
export function mapBodyToVehicleType(
  bodyLabel: string
): VehicleTypeFilterValue[] {
  return BODY_TO_VEHICLETYPE_MAP[bodyLabel] || [];
}

/**
 * Maps vehicletype filter values to body values
 * Used when querying the database
 */
export function mapVehicleTypeToBody(
  vehicleType: VehicleTypeFilterValue
): string[] {
  return VEHICLETYPE_TO_BODY_MAP[vehicleType] || [];
}

/**
 * Maps multiple vehicletype filter values to body values
 */
export function mapVehicleTypesToBodies(
  vehicleTypes?: VehicleTypeFilterValue[]
): string[] | null {
  if (!vehicleTypes || vehicleTypes.length === 0) return null;
  return vehicleTypes.flatMap(mapVehicleTypeToBody);
}
